import React, { useEffect, useRef, useState } from "react";


const MessageA433 = (props) => {
  const { inputValue, setShowFeedback, response, handleClick, setTextOnClick } = props;
  const [clickedButton, setClickedButton] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [inputVal, setInputVal] = useState("");
  const [selectedButton, setSelectedButton] = useState(null);

  const data = JSON.parse(response[0]?.data)
  const code = response[0]?.code

  const onClickHandler = (btnName) => {
    if (inputVal?.length > 0) {
      props?.inputValue?.current?.removeAttribute("disabled");
    }
    
    setClickedButton(btnName);
    setSelectedButton(btnName);
  };

  useEffect(() => {
    props?.inputValue?.current?.setAttribute("disabled", true);
  }, [])



  

  const [isLimitError, setIsLimitlError] = useState("");
  const handleChange = (e) => {
    let value = e?.target?.value; // Trim whitespace from the input value

    console.log(value.length);
    let specialCharRegex = /^[a-zA-Z., ]*$/;


    if (value.startsWith(" ")) {
      return;
    }

    if (value.length > 200) {
      setIsLimitlError("Maximum character limit is 200");
      return
    }


    if (value.length > 0 && clickedButton && specialCharRegex.test(value)) {
      props?.inputValue?.current?.removeAttribute("disabled");
      setErrorMessage("");
    } else if (!specialCharRegex.test(value)) {
      console.log(value.length)
      props?.inputValue?.current?.setAttribute("disabled", true);
      setErrorMessage("Special characters not allowed");
    } else {
      console.log(value.length)
      props?.inputValue?.current?.setAttribute("disabled", true);
      setErrorMessage("");
    }

    if (!value.startsWith(" ") && value.length >= 0) {
      setInputVal(value);
    }

    if (value.length > 200) {
      props?.inputValue?.current?.setAttribute("disabled", true);
      setIsLimitlError("Maximum character limit is 200");
    } else {
      setIsLimitlError("");
      // props?.inputValue?.current?.removeAttribute("disabled");
      localStorage.setItem(
        "inputValue",
        JSON.stringify({ key1: e.target.value })
      );
    }
  };
  const maxLength = 200;

  return (
    <>
      <style>
        {`
      .feedback-placeholder::placeholder {
        font-size: 14px; 
      }
    `}
      </style>
      <div style={{ marginTop: '12px' }}>
        <div>{data?.text}</div>

        <div style={{ marginTop: '12px' }}>
          {data?.buttons?.map((btn, index) => {
            const isSelected = selectedButton === btn;
            return (
              <button
              key={index}
              className={`chat-label action-tab ${isSelected ? 'selected' : ''}`}
              id="main-tab1"
              style={{
                cursor: "pointer",
                marginRight: isSelected ? '0px' : '10px',
                display: 'flex',
                flexWrap: 'wrap',
              }}
              onClick={() => onClickHandler(btn)}
            >
              {btn}
            </button>
            );
          })}
        </div>

        <div style={{ marginTop: '210px' }}>{data?.text_box_title}</div>
        <div style={{ marginTop: 10 }}>
          <div className="form-group">
            <input
              type="text"
              value={inputVal}
              onChange={handleChange}
              placeholder="Type here..."
              className="feedback-placeholder"
              style={{
                display: "block",
                width: "100%",
                height: "70px",
                backgroundColor: "#fff",
                border: "1px solid #ccc",
                fontSize: "14px",
                lineHeight: "70px",
                color: "#444",
                margin: "0px",
                boxShadow: "none",
                padding: "0 10px",
                verticalAlign: "top",
                boxSizing: "border-box",
              }}
            />
          </div>

          <span
            style={{
              display: "flex",
              // alignItems: "center",
              justifyContent: "start",
              marginTop: 10,
              fontSize: 14,
              color: 'rgb(170, 170, 170)'
            }}
          >
            Charateres left : {Math.max(maxLength - inputVal.length, 0)}
          </span>
          <div
            style={{
              color: "red",
              textAlign: "center",
              marginBlockStart: 10,
              fontSize: 13,
            }}
          >
            {isLimitError && isLimitError}
          </div>
          {errorMessage && (
            <div style={{ color: "red", paddingTop: "10px" }}>{errorMessage}</div>
          )}
        </div>
        <div style={{ marginTop: "10px", display: 'flex', justifyContent: 'end' }}>

          <button
            ref={inputValue}
            disabled={props?.disabled}
            className="submit-btn"
          >
            <span
              className={
                !props?.disable
                  ? "chat-label-fallback action-tab"
                  : "chat-labelnohover action-tab"
              }
              style={{ color: props.disable && "grey" }}
              id="main-tab1"
              onClick={() => {
                const input = JSON.parse(localStorage.getItem("inputValue"));
                const data = JSON.stringify({ button: clickedButton, text_input: input?.key1 })
                if (!props?.disable) {

                  props?.handleClick(code, data);
                  // props?.setTextOnClick(props?.item.text);
                }
                setShowFeedback(false)
              }}
            >
              Submit
            </span>
          </button>
        </div>
      </div>
    </>
  )
}

export default MessageA433
